<template>
    <div :class="`container pad-2 pcenter round-md pad-1-s bg-color-${bgColor}`">
        <h3 class="rel mrg-v-3">
            <span class="fsize-1d5 fsize-1-s">{{custom.title}}</span>
        </h3>
        <b-grid :col-data="custom.grid"
                :line="['neutral', 1]"
                :outline-color="bgColor">
            <div v-for="(item, index) of custom.grid.items" :slot="item.id" :key="item.id"
                 class="flex-column">
                <div class="pad-1d5">
                    <img :src="require(`@/assets/img/daas_case/${item.img}.png`)" class="h-3" />
                    <div class="fsize-1d7 mrg-v-1">{{item.user}}</div>
                    <div class="fsize-1d2 alpha-d5">{{item.pro_name}}</div>
                </div>
            </div>
        </b-grid>
    </div>
</template>

<script>
    import BGrid from "@/components/BTXUI/core/b-grid"

    export default {
        name: "sec-data-apply-widget",
        components: {
            BGrid
        },
        props: ["bgColor"],
        data(){
            return {

                //数据应用领域
                custom: {
                    title: "数据应用领域",
                    grid: {
                        common_plan: "col-4 col-6-s",
                        items: [
                            {
                                id: "icon1",
                                img: "icon1",
                                user: "科学研究",
                                pro_name: "科学院规划院智库",
                                show: false
                            },
                            {
                                id: "icon2",
                                img: "icon2",
                                user: "教育学术",
                                pro_name: "高校教授高校学生",
                                show: false
                            },
                            {
                                id: "icon3",
                                img: "icon3",
                                user: "数据服务",
                                pro_name: "为政企服务的数据分析公司",
                                show: false
                            },
                            {
                                id: "icon4",
                                img: "icon4",
                                user: "系统开发",
                                pro_name: "为政企服务的信息软件公司",
                                show: false
                            },
                            {
                                id: "icon5",
                                img: "icon5",
                                user: "金融投资",
                                pro_name: "银行保险投资",
                                show: false
                            },
                            {
                                id: "icon6",
                                img: "icon6",
                                user: "地产",
                                pro_name: "地产公司房产中介土地评估",
                                show: false
                            }
                        ]
                    }
                },

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/sec-data-apply-widget.vue